import React from "react";
import { COLORS, Typo } from "../../../../../layout/theme";
import {
	AntdTable,
	BigChartContainer,
	Container,
	Dashboard1Container,
	FilterContainer,
} from "./styles";
import { Button, DatePicker, Select, Tag } from "antd";
import DebounceSelectSeller from "../../../../../common/debounce-select-seller/DebounceSelectSeller";
import { CONSTANTS } from "../../../../../../utils/constants";
import { BiCheck, BiTrash } from "react-icons/bi";
import CustomAntdTooltip from "../../../../../common/custom-antd-tooltip/CustomAntdTooltip";

export default function ChainDashboard({
	distributors,
	selectDistributor,
	handleDateChange,
	deleteFilters,
	isLoading,
	selectedDistributor,
	chainsTable,
	rangeDate,
	selectedChain,
	selectChain,
	chains,
	userdata,
	selectedCategory,
	selectCategory,
	categories,
	sellers,
	selectSeller,
	selectedSeller,
	chainsPeriod,
	selectChainsPeriod,
	handleApplyFilters,
}) {
	const columns = [
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>Nombre</div>,
			width: 350,
			dataIndex: "chainName",
			render: (value, record) => <Typo level={5}>{value}</Typo>,
		},
		{
			title: () => <div style={{ color: COLORS.DarkGrey }}>Vendedores</div>,
			key: "sellerList",
			dataIndex: "sellerList",
			render: (_, { sellerList }) => (
				<>
					{sellerList.map((tag) => {
						let color = tag.length > 16 ? "geekblue" : "green";
						if (tag === "loser") {
							color = "volcano";
						}
						return (
							<Tag color={color} key={tag}>
								{tag.toUpperCase()}
							</Tag>
						);
					})}
				</>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey }}>Ordenes totales</div>
			),
			dataIndex: "totalOrders",
			width: 150,
			render: (value, record) => (
				<Typo type="primary" level={3}>
					{value}
				</Typo>
			),
		},
		{
			title: () => (
				<div style={{ color: COLORS.DarkGrey }}>Unidades totales</div>
			),
			dataIndex: "totalUnits",
			width: 150,
			render: (value, record) => (
				<Typo type="secondary" level={3}>
					{value}
				</Typo>
			),
		},
	];

	return (
		<Dashboard1Container>
			<FilterContainer>
				<Container
					style={{
						flexDirection: "row",
						alignItems: "end",
						justifyContent: "center",
						width: "140px",
					}}
				>
					<CustomAntdTooltip
						placement="top"
						width="110px"
						tooltipContent={[
							{
								title: `Aplicar filtros`,
							},
						]}
					>
						<Button
							type="primary"
							onClick={handleApplyFilters}
							icon={<BiCheck />}
							style={{
								borderRadius: 20,
								backgroundColor: COLORS.Success,
								borderColor: COLORS.Success,
							}}
						/>
					</CustomAntdTooltip>
					<CustomAntdTooltip
						placement="top"
						width="100px"
						tooltipContent={[
							{
								title: `Borrar filtros`,
							},
						]}
					>
						<Button
							type="danger"
							onClick={deleteFilters}
							icon={<BiTrash />}
							style={{ borderRadius: 20 }}
						/>
					</CustomAntdTooltip>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Fecha
					</Typo>
					{/* <DatePicker.RangePicker onChange={(e) => handleDateChange(e)} /> */}
					{rangeDate ? (
						<DatePicker.RangePicker
							format="DD/MM/YYYY"
							value={rangeDate}
							onChange={(e) => handleDateChange(e)}
							disabled={chainsPeriod === CONSTANTS.PERIOD_CURRENT}
						/>
					) : (
						<DatePicker.RangePicker
							format="DD/MM/YYYY"
							onChange={(e) => handleDateChange(e)}
							placeholder={["Desde", "Hasta"]}
							disabled={chainsPeriod === CONSTANTS.PERIOD_CURRENT}
						/>
					)}
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Período
					</Typo>
					<Select
						showSearch
						//allowClear
						placeholder="Período"
						optionFilterProp="children"
						value={chainsPeriod}
						onChange={(e) => selectChainsPeriod(e)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={CONSTANTS.MOBILE_DASHBOARD_PERIODS}
						style={{ width: 130 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Droguería
					</Typo>
					<Select
						showSearch
						//allowClear
						placeholder="Droguería"
						optionFilterProp="children"
						value={selectedDistributor}
						// defaultValue={selectedDistributor ?? null}
						onChange={(e, o) => selectDistributor(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={distributors}
						style={{ width: 150 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Cadena
					</Typo>
					<Select
						showSearch
						placeholder="Cadena"
						optionFilterProp="children"
						value={selectedChain}
						onChange={(e, o) => selectChain(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={chains}
						style={{ width: 140 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Categoria
					</Typo>
					<Select
						showSearch
						// allowClear
						placeholder="Categoria"
						optionFilterProp="children"
						value={selectedCategory}
						onChange={(e, o) => selectCategory(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={categories}
						style={{ width: 180 }}
					/>
				</Container>
				{!(!userdata.p_shop && userdata.p_mobile) && (
					<Container>
						<Typo type="primary" level={6}>
							Vendedor
						</Typo>
						<DebounceSelectSeller
							fetchCallback={sellers}
							placeholder="Vendedor"
							onValuesChange={selectSeller}
							initialValues={selectedSeller}
						/>
					</Container>
				)}
			</FilterContainer>
			<BigChartContainer>
				<AntdTable
					dataSource={chainsTable}
					loading={isLoading}
					columns={columns}
					pagination={false}
					scroll={{ y: "1020px" }}
				/>
			</BigChartContainer>
		</Dashboard1Container>
	);
}
